var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('the-modal'),_c('the-sidebar'),_c('div',{staticClass:"app-content"},[_c('the-header'),_vm._t("default"),_c('the-fab-scroll-top')],2),(_vm.$route.meta.ui === undefined || _vm.$route.meta.ui.footer)?_c('the-footer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }